var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{class:this.class || ['font-size-80', 'text-uppercase', 'font-weight-500'],attrs:{"variant":_vm.variant}},[(!_vm.label)?_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]}):[_vm._v(_vm._s(_vm.label))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }